import { useNavigate } from "react-router";

export default function Piano() {
    const navigate = useNavigate()
    return (
        <div
            style={{
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                maxWidth: "800px",
                margin: "50px auto",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#0d9f7d",
                    marginBottom: "20px",
                }}
            >
                My Piano Journey
            </h2>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                I’ve been playing the piano since I was 8 years old, and it has
                been an integral part of my life ever since. I was classically trained
                for 7 years at my school, where I developed a strong foundation in
                technique and musicality. These formative years taught me discipline,
                expression, and the joy of creating music.
            </p>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                Today, playing the piano has become one of my favorite ways to unwind
                and express myself. Whether it’s revisiting old pieces, improvising,
                or learning new melodies, the piano continues to be a source of
                inspiration and enjoyment in my life.
            </p>
            <div
                style={{
                    textAlign: "center",
                    marginTop: "20px",
                }}
            >
                <img
                    src="/images/piano.png"
                    alt="Piano"
                    style={{
                        maxWidth: "100%",
                        width:"500px",
                        height: "400px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    }}
                />
            </div>
            <p
                style={{
                    marginTop: "20px",
                    fontStyle: "italic",
                    textAlign: "center",
                    color: "#555",
                }}
            >
                "Music is a higher revelation than all wisdom and philosophy."
                <br />
                <span style={{ fontWeight: "bold" }}>– Ludwig van Beethoven</span>
            </p>

            <div className="mt-3">
                <button
                    onClick={() => navigate("/Rayan/Home")} 
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#0d9f7d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
}
